<template>
    <div>
        <v-chart v-bind:chartData="chartData" ref="chartComponent"></v-chart>
    </div>
</template>

<script>
    export default {
        name: "ChartDraw",
        props: ['chartData'],
        data() {
            return {
            };
        },
        methods: {
            graph() {
                this.$refs.chartComponent.clearCanvas();
                this.$refs.chartComponent.initalizeChart();
            }
        },
    }
</script>